/**
 * DetailClassification element.
 * Renders the commercial score (when present) and parental age rating side by side.
 */
import AgeCode from '../ageCode/ageCode';
import Container from '@components/atoms/container/detailClassificationContainer';
import DetailContext from '@shared/components/utils/context/detailContext';
import Score from '../rating/score';
import { useContext } from 'react';

/**
 * Displays classification UI for the current detail asset: score and age code.
 */
export default function DetailClassification() {
  const { metadata } = useContext(DetailContext);
  return (
    <Container>
      <Score score={metadata?.commercialScoreText} />
      <AgeCode
        ageCode={metadata?.ageCode}
        margin={!!metadata?.commercialScoreText}
      />
    </Container>
  );
}
